import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Filter = ({
  className = '',
  fill = colors.boulder,
  size = 14,
  title = 'Filter',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 14 9"
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M7.23,0h5.95c.45,0,.84.11,1,.63.19.71-.19,1.17-1,1.17q-4,0-8.11,0H1.32C.57,1.79.18,1' +
          '.45.21.86S.62,0,1.33,0Z'
        }
        transform="translate(-0.21)"
        fill={fill}
      />
      <path
        d={
          'M7.18,5.37H2.94c-.68,0-1-.3-1-.9s.31-.83,1-.83q4.27,0,8.55,0c.67,0,1,.32,1,.9s-.35.8' +
          '3-1,.83Z'
        }
        transform="translate(-0.21)"
        fill={fill}
      />
      <path
        d="M7.22,9H4.75c-.69,0-1-.3-1-.88s.3-.91,1-.92h5a.88.88,0,0,1,1,.92c0,.55-.37.87-1,.88Z"
        transform="translate(-0.21)"
        fill={fill}
      />
    </svg>
  );
};
